import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, BadgeCheck } from "lucide-react";
import api from "@/lib/api";

const Stars = ({ n }) => (
  <div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={16} className={i <= n ? "fill-[#B87333] text-[#B87333]" : "text-[#E6DEC3]"} />)}</div>
);

export function ReviewCard({ r }) {
  return (
    <div className="bg-white rounded-2xl border border-[#E6DEC3] p-6 shadow-[0_4px_20px_rgba(44,38,33,0.04)] flex flex-col" data-testid={`review-card-${r.review_id}`}>
      <Stars n={r.rating} />
      {r.title && <h4 className="mt-3 font-serif text-lg text-[#2C2621]">{r.title}</h4>}
      <p className="mt-2 text-sm text-[#635B52] leading-relaxed flex-1">"{r.body}"</p>
      <div className="mt-4 flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-[#2C2621]">{r.display_name}</p>
          {r.service_label && <p className="text-xs text-[#635B52]">{r.service_label}</p>}
        </div>
        {r.verified && <span className="inline-flex items-center gap-1 text-xs text-[#B87333] bg-[#F5F0E8] rounded-full px-2.5 py-1" data-testid="verified-badge"><BadgeCheck size={13} /> Verified Customer</span>}
      </div>
    </div>
  );
}

export default function ReviewsSection({ featured = false, showReadMore = true }) {
  const [reviews, setReviews] = useState(null);
  useEffect(() => {
    api.get(`/reviews/public${featured ? "?featured=true&limit=3" : "?limit=60"}`).then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, [featured]);

  if (!reviews || reviews.length === 0) return null; // hide when empty

  return (
    <section className="bg-[#F5F0E8] py-20" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#B87333]">Reviews</span>
          <h2 className="mt-2 font-serif text-3xl sm:text-4xl text-[#2C2621]">Featured Customer Reviews</h2>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {reviews.map((r) => <ReviewCard key={r.review_id} r={r} />)}
        </div>
        {featured && showReadMore && (
          <div className="mt-10 text-center">
            <Link to="/reviews" className="inline-block border border-[#B87333] text-[#B87333] rounded-full px-6 py-3 text-sm font-medium hover:bg-[#B87333] hover:text-white transition-colors" data-testid="read-more-reviews">Read more reviews</Link>
          </div>
        )}
      </div>
    </section>
  );
}
